import http from "../../http-common";

class CompanyDataService {
  getAll() {
    return http.get("/ecommerce_api/companydetails");
  }
}

export default new CompanyDataService();